import { Text } from '@chakra-ui/react';
import type { BoxProps } from '@chakra-ui/react';

type Omitted = 'fontWeight';

export type MediumTextProps = Omit<BoxProps, Omitted> & {
  text: string | number;
};

export const MediumText = ({ text, ...rest }: MediumTextProps): JSX.Element => (
  <Text fontWeight="400" {...rest}>
    {text}
  </Text>
);
